import DocumentDetailPage from "../features/documents/DocumentDetailPage";

export default function DocumentDetailRoute() {
  return <DocumentDetailPage />;
}
